import { Link } from "react-router-dom";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolveImg = (p) => !p ? undefined : (p.startsWith("http") ? p : `${BACKEND}${p}`);

export default function WalkCard({ walk, index = 0 }) {
    return (
        <Link
            to={`/balades/${walk.slug}`}
            data-testid={`walk-card-${walk.slug}`}
            className="group block"
        >
            <div className="cp-image-zoom aspect-[4/5] overflow-hidden bg-cp-craie mb-5">
                <img src={resolveImg(walk.hero_image || walk.image)} alt={walk.title} loading="lazy" className="w-full h-full object-cover cp-photo-warm" />
            </div>
            <div className="flex items-baseline gap-3">
                <span className="cp-serif text-2xl italic text-cp-sable-deep">N°{index + 1}</span>
                <div className="flex-1">
                    <p className="cp-tiny text-cp-sable-deep mb-2">{walk.theme} · {walk.difficulty}</p>
                    <h3 className="cp-serif text-2xl md:text-3xl leading-tight text-cp-encre group-hover:italic transition-all">
                        {walk.title}
                    </h3>
                    <p className="cp-serif italic text-base text-cp-gris mt-2 leading-snug max-w-md">
                        {walk.short_description}
                    </p>
                    <p className="cp-mono text-xs text-cp-gris mt-4">{walk.distance_km} km · {walk.duration_minutes} min</p>
                </div>
            </div>
        </Link>
    );
}
